import {
  AsyncActionState,
  asyncActionStateMatchers,
  setupSlice,
  invoke,
} from '@owl-frontend/redux';
import runsApiClient from '../../api/runs/client';
import { Run } from '../../api/runs/interface';

export interface RunState {
  runs: {
    [dossier_id: string]: Run[];
  };
  selected_runs: {
    [dossier_id: string]: Run;
  };
  actions: {
    runs: AsyncActionState;
  };
}

const initialState: RunState = {
  runs: {},
  selected_runs: {},
  actions: {
    runs: { status: 'uninitialized' },
  },
};

const slice = setupSlice('runs', initialState)
  .addAsyncSagas({
    runs: invoke(runsApiClient.runs),
  })
  .addReducers({
    'runs/fulfilled': (state, action) => {
      state.runs[action.meta.arg] = action.payload;
    },
  })
  .addReducers({
    setSelectedRun: (state, action: { payload: Run }) => {
      state.selected_runs[action.payload.dossier_id] = action.payload;
    },
  });

export const actions = slice.actions;
export default slice.addExtra(asyncActionStateMatchers(actions).all());
